import { Flex, Grid } from '@sequencehq/core-components'
import { COMPACT_COLUMN_WIDTHS, STYLES } from './pricingTableCompact.constants'
import { useProductReordering } from 'Cube/domain'

export const PricingTableCompactHeader = () => {
  const { enabled: reorderEnabled } = useProductReordering()
  return (
    <Grid
      templateColumns={COMPACT_COLUMN_WIDTHS}
      paddingLeft={reorderEnabled ? '20px' : '0'}
      paddingRight="16px"
    >
      <Flex {...STYLES.tableHeader}>PRODUCT</Flex>
      <Flex {...STYLES.tableHeader}>FREQUENCY</Flex>
      <Flex {...STYLES.tableHeader}>DISCOUNT</Flex>
      <Flex {...STYLES.tableHeader} justifyContent="flex-end">
        PRICE
      </Flex>
      <Flex {...STYLES.tableHeader}></Flex>
    </Grid>
  )
}
